<template>
  <div>
    <v-card class="edit-location-card">
      <v-form ref="form"
              v-model="valid"
              :disabled="loading"
      >
        <v-card-title>Location change</v-card-title>
        <v-select
          :items="AllAliasTypes"
          item-text="1"
          item-value="0"
          v-model="editedLocation.type"
          label="Type of location"
          :rules="[rules.required]"
        ></v-select>
        <v-card-text>
          <v-text-field
            autofocus
            v-model="editedLocation.name"
            label="Name"
            :rules="[rules.required]"
          ></v-text-field>
          <v-text-field
            :key="editedLocation.type"
            v-model="editedLocation.path"
            label="Path"
            :rules="[
              rules.pathRules,
              rules.startsWithHttp,
              rules.networkCorrect,
            ]"
          ></v-text-field>
          <div v-if="editedLocation.type === AliasType.s3Bucket || editedLocation.type === AliasType.genericS3 || editedLocation.type === AliasType.googleCloudBucket || editedLocation.type === AliasType.azureContainer">
            <v-select
              :items="delimiters"
              v-model="editedLocation.delimiter"
              label="Delimiter"
            ></v-select>
          </div>
          <v-select
            :items="trueFalse"
            v-model="editedLocation.hidden"
            label="Hidden"
          ></v-select>
          <div v-if="editedLocation.type === AliasType.network">
            <v-text-field
              v-model="editedLocation.username"
              label="Username"
            ></v-text-field>
            <v-switch
              v-if="!loading && !aliasTypeChanged"
              v-model="editSecrets"
              :label="'Update password'"
              style="width: fit-content"
            ></v-switch>
            <v-text-field
              v-if="fullEdit"
              v-model       = "editedLocation.password"
              label         = "Password"
              :append-icon  = "showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type         = "showPassword ? 'text' : 'password'"
              @click:append = "showPassword = !showPassword"
            ></v-text-field>
          </div>
          <div v-if="editedLocation.type === AliasType.s3Bucket">
            <v-text-field
              v-model="editedLocation.bucket"
              label="Bucket"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model="editedLocation.region"
              label="Region"
              :rules="[rules.required]"
            ></v-text-field>
            <v-switch
              v-if="!loading && !aliasTypeChanged"
              v-model="editSecrets"
              :label="'Update access keys'"
              style="width: fit-content"
            ></v-switch>
            <v-text-field
              v-if="fullEdit"
              v-model="editedLocation.accessKey"
              label="Access Key"
            ></v-text-field>
            <v-text-field
              v-if          = "fullEdit"
              v-model       = "editedLocation.secretAccessKey"
              label         = "Secret Access Key"
              :append-icon  = "showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type         = "showPassword ? 'text' : 'password'"
              @click:append = "showPassword = !showPassword"
            ></v-text-field>
          </div>
          <div v-if="editedLocation.type === AliasType.genericS3">
            <v-text-field
              v-model="editedLocation.bucket"
              label="Bucket"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model="editedLocation.serviceUrl"
              label="Service URL"
              :rules="[rules.required, rules.startsWithHttp]"
            ></v-text-field>
            <v-switch
              v-if="!loading && !aliasTypeChanged"
              v-model="editSecrets"
              :label="'Update access keys'"
              style="width: fit-content"
            ></v-switch>
            <v-text-field
              v-if="fullEdit"
              v-model="editedLocation.accessKey"
              label="Access Key"
            ></v-text-field>
            <v-text-field
              v-if          = "fullEdit"
              v-model       = "editedLocation.secretAccessKey"
              label         = "Secret Access Key"
              :append-icon  = "showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type         = "showPassword ? 'text' : 'password'"
              @click:append = "showPassword = !showPassword"
            ></v-text-field>
          </div>
          <div v-if="editedLocation.type === AliasType.googleCloudBucket">
            <v-text-field
              v-model="editedLocation.bucket"
              label="Bucket"
              :rules="[rules.required]"
            ></v-text-field>
            <v-switch
              v-if="!loading && !aliasTypeChanged"
              v-model="editSecrets"
              :label="'Update JSON path'"
              style="width: fit-content"
            ></v-switch>
            <v-text-field
              v-if="fullEdit"
              v-model="editedLocation.connectionString"
              label="JSON path"
              :rules="[rules.required]"
            ></v-text-field>
          </div>
          <div v-if="editedLocation.type === AliasType.azureContainer">
            <v-text-field
              v-model="editedLocation.container"
              label="Container"
              :rules="[rules.required]"
            ></v-text-field>
            <v-switch
              v-if="!loading && !aliasTypeChanged"
              v-model="editSecrets"
              :label="'Update connection string'"
              style="width: fit-content"
            ></v-switch>
            <v-text-field
              v-if="fullEdit"
              v-model="editedLocation.connectionString"
              label="Connection String"
              :rules="[rules.required]"
            ></v-text-field>
          </div>
          <div>
            <v-text-field
              v-model = "editedLocation.cacheExpiration"
              label   = "Cache Expiration (s)"
              :rules  = "[rules.required]"
            ></v-text-field>
          </div>
          <div>
            <v-checkbox
              v-model   = "editedLocation.backgroundCaching"
              label     = "Background Caching"
              ></v-checkbox>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            :disabled="!valid || loading"
            @click="testConnection(editedLocation)"
            v-if="!loading"
          >
            Test connection
          </v-btn>
          <v-btn text
                 @click="cancelTest"
                 v-if="loading"
          >
            <v-icon left>mdi-loading mdi-spin</v-icon>Cancel test
          </v-btn>
          <div class="row row--end">
            <v-btn text
                   @click="cancel"
                   :disabled="loading"
            >Cancel </v-btn>
            <v-btn
              text
              color="primary"
              @click="save()"
              :disabled="!valid || loading"
            >
              Save
            </v-btn>
          </div>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import {
  AliasType,
  AllAliasTypes,
  HttpTypes
} from "../../services/locations.services";
import { HubConnection } from "@microsoft/signalr";
import { LocationTester } from "../../services/LocationTester";

export default {
  name:  "EditLocationsForm",
  props: {
    connection:  HubConnection,
    location:    Object,
    showSuccess: Function,
    showFailure: Function,
  },
  computed: {
    aliasTypeChanged() {
      return this.location.type != this.editedLocation.type;
    },
    fullEdit() {
      return this.aliasTypeChanged || this.editSecrets;
    },
  },
  data() {
    return {
      editSecrets: false,
      valid:       false,
      trueFalse:   [true, false],
      delimiters:  ["/","\\"],
      loading:     false,

      locationTester: null,
      showPassword:   false,

      AliasType,
      AllAliasTypes,
      HttpTypes,

      editedLocation: {
        type: AliasType.physical,
      },

      rules: {
        required:       (value) => !!value || "Required",
        notANumber:     (value) => !isNaN(value) || "Number required",
        nonNegative:    (value) => value >= 0 || "Non-negative number required",
        startsWithHttp: (value) => {
          if (this.HttpTypes.has(this.editedLocation.type)) {
            return (
              value.startsWith("http://") ||
              value.startsWith("https://") ||
              "Value needs to start with 'http://' or https://"
            );
          } else {
            return true;
          }
        },
        networkCorrect: (value) => {
          if (this.editedLocation.type === AliasType.network) {
            return (
              value.startsWith("\\\\") || "Network needs to start with '\\\\'"
            );
          } else {
            return true;
          }
        },
        pathRules: (path) => {
          if (
            this.editedLocation.type === AliasType.s3Bucket ||
            this.editedLocation.type === AliasType.genericS3 ||
            this.editedLocation.type === AliasType.googleCloudBucket ||
            this.editedLocation.type === AliasType.azureContainer
          ) {
            return true;
          } else {
            return this.rules.required(path);
          }
        },
      },
    };
  },
  mounted() {
    this.editedLocation = JSON.parse(JSON.stringify(this.location));
    this.locationTester = new LocationTester(this.connection);
  },
  methods: {
    save() {
      let saveMethod = this.fullEdit ? "EditAliasFully" : "EditAliasPartially";

      return this.connection
        .invoke(saveMethod, this.editedLocation)
        .then((response) => {
          if (response.resultKind === "Success") {
            this.$emit("locations-updated", response.entity);
            this.$emit("ok");
          } else {
            this.$emit("failure", response.reason);
          }
        })
        .catch((reason) => {
          this.$emit("failure", reason);
        });
    },
    cancel() {
      this.$emit("cancel");
    },
    cancelTest() {
      this.locationTester.cancelTest();
    },
    async testConnection(location) {
      this.loading = true;

      let testPromise = this.fullEdit
        ? this.locationTester.testAliasConnection(location)
        : this.locationTester.testAliasDtoConnection(location);

      testPromise.then(
        (response) => {
          if (response.resultKind === "Success") {
            this.showSuccess("Success");
          } else {
            this.showFailure(response.reason);
          }
          this.loading = false;
        },
        (error) => {
          this.showFailure(error);
          this.loading = false;
        }
      );
    },
  },
};
</script>

<style>
.edit-location-card{
  min-width: 450px;
  padding: 20px;
}
</style>
